import {apiHelper} from "../redux/apiHelper"
export const getCmsAboutSection=async()=>{
    try{
       let res=await apiHelper('get','/api/admin/cms-about-section/list');
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
 }
 export const addCmsAboutSection=async(data)=>{

    try{
        let res=await apiHelper('post',`/api/admin/cms-about-section/create`,data);
        if(res){
          return res;
        }
     }catch(e){
        console.log(e);
     }
 }
 export const updateCmsAboutSection=async(id,data)=>{
   try{
       let res=await apiHelper('post',`/api/admin/cms-about-section/update/${id}`,data);
       if(res){
         return res;
       }
    }catch(e){
       console.log(e);
    }
}
export const getCmsAboutSectionById=async(id)=>{
   try{
       let res=await apiHelper('get',`/api/admin/cms-about-section/get/${id}`);
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
}
 export const deleteCmsAboutSectionById=async(id)=>{
    try{
        let res=await apiHelper('delete',`/api/admin/cms-about-section/delete/${id}`);
        if(res){
          return res;
        }
     }catch(e){
      console.log(e);
     }
    
}